'use strict';
import React from 'react';
import PropTypes from 'prop-types';

export const ValuePropositionPanelsHome = props => {
    return (
        <div className='section section-item'>
            <div className='section-title'>
                <h3 className='tw-text-[24px] tw-font-bold tw-text-primary-500'>Why BCAA Task Marketplace?</h3>
                <div className='divider'></div>
            </div>

            <div className='container'>
                <div className='group-list'>
                    {props.panel.Details.map(function (detail) {
                        return (
                            <div className='item-list-container tw-mb-[60px] lg:tw-mb-0' key={detail.ID}>
                                <div className='tw-w-[80%] tw-m-auto'>
                                    <div>
                                        {detail.Url ? (
                                            <a href={'https://' + detail.Url}>
                                                <img
                                                    className='tw-rounded-none tw-w-[135px] tw-h-[135px] tw-mx-auto tw-mb-[25px] tw-mt-0'
                                                    src={detail.PanelMedia[0].MediaUrl}
                                                    alt={detail.Title}
                                                    loading='lazy'
                                                    decoding='async'
                                                    width={135}
                                                    height={135}
                                                />
                                            </a>
                                        ) : (
                                            <img
                                                className='tw-rounded-none tw-w-[135px] tw-h-[135px] tw-mx-auto tw-mb-[25px] tw-mt-0'
                                                src={detail.PanelMedia[0].MediaUrl}
                                                alt={detail.Title}
                                                loading='lazy'
                                                decoding='async'
                                                width={135}
                                                height={135}
                                            />
                                        )}
                                    </div>
                                    <div className='tw-text-[18px] tw-font-bold tw-text-primary-500 tw-px-[26px]'>
                                        {detail.Title}
                                    </div>
                                    <div className='tw-text-black tw-py-[8px] tw-px-[26px]'>{detail.Description}</div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

ValuePropositionPanelsHome.propTypes = {
    panel: PropTypes.shape({
        Details: PropTypes.arrayOf(
            PropTypes.shape({
                ID: PropTypes.string.isRequired,
                Url: PropTypes.string,
                Title: PropTypes.string,
                Description: PropTypes.string,
                PanelMedia: PropTypes.arrayOf(
                    PropTypes.shape({
                        MediaUrl: PropTypes.string
                    })
                )
            })
        )
    })
};
